import React from "react";
import { MotionConfig } from "framer-motion";
import "./App.css";
import SmoothScroll from "./components/SmoothScroll";
import Header from "./components/Header";
import Hero from "./components/Hero";
import FactsStrip from "./components/FactsStrip";
import WhoWeServe from "./components/WhoWeServe";
import Scope from "./components/Scope";
import Commitment from "./components/Commitment";
import HowWeWork from "./components/HowWeWork";
import People from "./components/People";
import InsightsBlock from "./components/InsightsBlock";
import Invite from "./components/Invite";
import Footer from "./components/Footer";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: "48px 24px", fontFamily: "var(--font-sans)" }}>
          <p>Something went wrong. Please refresh the page.</p>
        </div>
      );
    }
    return this.props.children;
  }
}

function App() {
  return (
    <MotionConfig reducedMotion="user">
      <ErrorBoundary>
        <a className="skip-link" href="#main">
          Skip to content
        </a>
        <SmoothScroll />
        <Header />
        <main id="main">
          <Hero />
          <FactsStrip />
          <WhoWeServe />
          <Scope />
          <Commitment />
          <HowWeWork />
          <People />
          <InsightsBlock />
          <Invite />
        </main>
        <Footer />
      </ErrorBoundary>
    </MotionConfig>
  );
}

export default App;
